import React from 'react';
import { Card, Result, Button, Descriptions, Space } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';

interface PaymentResultProps {
  transactionId: string;
  account: string;
  amount: number;
  phone?: string;
  promo?: string;
  onNewPayment: () => void;
}

const PaymentResult: React.FC<PaymentResultProps> = ({
  transactionId,
  account,
  amount,
  phone,
  promo,
  onNewPayment,
}) => {
  return (
    <Card
      style={{
        width: '100%',
        maxWidth: 500,
      }}
    >
      <Result
        icon={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
        status="success"
        title="Платеж успешно запланирован!"
        subTitle="Ваш платеж запланирован и скоро будет обработан."
        extra={[
          <Button type="primary" size="large" onClick={onNewPayment} key="new">
            Совершить еще один платеж
          </Button>,
        ]}
      />

      <Descriptions
        bordered
        column={1}
        size="small"
        style={{ marginTop: 24 }}
      >
        <Descriptions.Item label="ID транзакции">
          <code style={{ fontSize: '12px' }}>{transactionId}</code>
        </Descriptions.Item>
        <Descriptions.Item label="Аккаунт">
          <strong>{account}</strong>
        </Descriptions.Item>
        <Descriptions.Item label="Сумма">
          <strong style={{ fontSize: '18px', color: '#52c41a' }}>
            {amount} ₸
          </strong>
        </Descriptions.Item>
        {phone && (
          <Descriptions.Item label="Телефон">
            {phone}
          </Descriptions.Item>
        )}
        {promo && (
          <Descriptions.Item label="Промо-код">
            <span style={{ color: '#1890ff', fontWeight: 'bold' }}>
              {promo}
            </span>
          </Descriptions.Item>
        )}
      </Descriptions>

      <div
        style={{
          marginTop: 24,
          padding: '12px',
          background: '#f0f5ff',
          borderRadius: '8px',
          border: '1px solid #d6e4ff',
        }}
      >
        <Space direction="vertical" size="small">
          <span style={{ fontSize: '12px', color: '#1890ff' }}>
            ℹ️ <strong>Важно:</strong>
          </span>
          <span style={{ fontSize: '12px', color: '#595959' }}>
            Пожалуйста, сохраните ID транзакции для дальнейшего использования. Он может понадобиться для отслеживания статуса платежа.
          </span>
        </Space>
      </div>
    </Card>
  );
};

export default PaymentResult;
